import React, { useEffect, useState } from 'react'
import {
  fetchAccessories,
  deleteAccessory,
  updateAccessory,
  createAccessory,
  fetchPhotoBooths
} from 'helpers/backend_helper'
import { APIClient } from 'helpers/api_helper'
import { Container } from 'reactstrap'
import BreadCrumb from 'Components/Common/BreadCrumb'
import { toast } from 'react-toastify'
import AccessoriesTable from './AccessoriesTable'
import AccessoryModal from './AccessoryModal'

export interface IAccessory {
  _id?: string
  name: string
  imageLink: string
  category: string
  translations: Record<string, string>
  parts: any[]
  isActive: boolean
  isActiveFor: string[]
}

export interface ICategory {
  _id: string
  name: string
}

export interface IPhotoBooth {
  _id: string
  name: string
}

const Accessories = () => {
  document.title = 'Aksesuarlar | SocialBooth - Admin Dashboard'

  const [fetching, setFetching] = useState<boolean>(false)
  const [accessoryRecords, setAccessoryRecords] = useState<IAccessory[]>([])
  const [categories, setCategories] = useState<ICategory[]>([])
  const [photoBooths, setPhotoBooths] = useState<IPhotoBooth[]>([])
  const [openAccessoryPopup, setOpenAccessoryPopup] = useState<boolean>(false)
  const [currentAccessory, setCurrentAccessory] = useState<IAccessory>()
  const [editMode, setEditMode] = useState<boolean>(false)

  const fetchAccessoryRecords = async () => {
    try {
      setFetching(true)
      const response = await fetchAccessories()
      if (Array.isArray(response.data)) {
        setAccessoryRecords(response.data)
      } else if (response.data.success) {
        setAccessoryRecords(response.data.data)
      }
      setFetching(false)
    } catch (e: any) {
      toast.error(typeof e === 'string' ? e : (e.message || 'Aksesuarlar yuklenirken hata olustu'))
      setFetching(false)
    }
  }

  const fetchCategoryList = async () => {
    try {
      const api = new APIClient()
      const res: any = await api.get('/api/v1/accessories/categories', null)
      let catNames: string[] = []
      if (res?.success && Array.isArray(res.data)) {
        catNames = res.data
      } else if (Array.isArray(res?.data?.data)) {
        catNames = res.data.data
      } else if (Array.isArray(res?.data)) {
        catNames = res.data
      }
      setCategories(
        catNames.filter(Boolean).map((name: string) => ({ _id: name, name }))
      )
    } catch (e: any) {
      console.error('Kategoriler yuklenemedi:', e)
    }
  }

  const fetchBoothList = async () => {
    try {
      const response = await fetchPhotoBooths()
      if (Array.isArray(response.data)) {
        setPhotoBooths(response.data)
      } else if (response.data.success) {
        setPhotoBooths(response.data.data)
      }
    } catch (e: any) {
      console.error('Booth listesi yuklenemedi:', e)
    }
  }

  useEffect(() => {
    fetchAccessoryRecords()
    fetchCategoryList()
    fetchBoothList()
  }, [])

  const handleOpenDetails = (id: string) => {
    const selectedAccessory = accessoryRecords.find((acc) => acc._id === id)
    if (selectedAccessory) {
      setCurrentAccessory(selectedAccessory)
      setOpenAccessoryPopup(true)
    }
  }

  const handleCreateOrUpdateAccessory = async (params: any) => {
    try {
      const id = params instanceof FormData ? params.get('_id') as string : params._id
      const response: any = editMode
        ? await updateAccessory(params, id)
        : await createAccessory(params)

      if (response.success) {
        if (editMode) {
          const updatedRecords = accessoryRecords.map((acc: IAccessory) => {
            if (acc._id === response.data._id) {
              return response.data
            }
            return acc
          })
          setAccessoryRecords(updatedRecords)
        } else {
          setAccessoryRecords([response.data, ...accessoryRecords])
        }
        return 'SUCCESSFULL'
      }
      return response.msg || 'Hata olustu'
    } catch (e: any) {
      return typeof e === 'string' ? e : (e.message || 'Aksesuar kaydedilirken hata olustu')
    }
  }

  const handleDeleteAccessory = async (id: string) => {
    try {
      const response: any = await deleteAccessory(id)
      if (response.success) {
        setAccessoryRecords(accessoryRecords.filter((acc) => acc._id !== id))
        return 'SUCCESSFULL'
      }
      return response.msg || 'Hata olustu'
    } catch (e: any) {
      toast.error(typeof e === 'string' ? e : (e.message || 'Aksesuar silinirken hata olustu'))
      return 'FALSE'
    }
  }

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Aksesuarlar' pageTitle='Asset Management' />
          <AccessoriesTable
            accessoryRecords={accessoryRecords}
            setOpenAccessoryPopup={setOpenAccessoryPopup}
            handleOpenDetails={handleOpenDetails}
            setEditMode={setEditMode}
            handleDeleteAccessory={handleDeleteAccessory}
            fetching={fetching}
          />
          <AccessoryModal
            isOpen={openAccessoryPopup}
            setOpenPopup={setOpenAccessoryPopup}
            handleCreateOrUpdateAccessory={handleCreateOrUpdateAccessory}
            accessoryRecord={currentAccessory}
            editMode={editMode}
            categories={categories}
            photoBooths={photoBooths}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Accessories
